import { styled } from "styled-components";

export const ServiceDetailWrapper = styled.div`
    text-align: left;

.header-hero-container {
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 305px;
    height: auto;
}

.service-detail {
    @media screen and (max-width: 1000px){
        img {
            width: 95%;
        }
    }
}
`;

